// extracted by mini-css-extract-plugin
export var navSelect = "NavSelect_navSelect__gBIWq";